import { Link } from 'react-router-dom'
import { LandingIcon, ArrowRightIcon } from './icons'
import {
  sorteeLandingProofItems,
  sorteeLandingTestimonials,
  sorteeLandingTestimonialsHeading,
  sorteeLandingHeroDashboard,
  sorteeLandingFloatingPills,
  sorteeLandingFeatures,
  sorteeLandingFeaturesVisualContent,
  sorteeLandingHowCards,
  sorteeLandingTrustAvatars,
} from '../content/sorteeLandingContent'
import page from '../SorteeLandingPage.module.css'
import styles from './RestoredContent.module.css'

export function RestoredHeroTrust() {
  return (
    <div className={styles.trust}>
      <div className={styles.avatars} aria-hidden="true">
        {sorteeLandingTrustAvatars.map((person, index) => (
          <span key={index}>{person.initials}</span>
        ))}
      </div>
      <Rating />
    </div>
  )
}
function Rating() {
  return (
    <span className={styles.rating} role="img" aria-label="5 estrelas">
      {Array.from({ length: 5 }, (_, index) => (
        <svg
          key={index}
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="m12 3 2.8 5.7 6.3.9-4.55 4.44 1.08 6.26L12 17.35l-5.63 2.95 1.08-6.26L2.9 9.6l6.3-.9Z" />
        </svg>
      ))}
    </span>
  )
}
export function RestoredProof() {
  return (
    <section
      className={`${page.container} ${styles.proof}`}
      aria-label="Resultados da plataforma"
    >
      {sorteeLandingProofItems.map((item) => (
        <div key={item.label}>
          <strong>
            {item.prefix}
            {Number(item.target).toLocaleString('pt-BR')}
            {item.suffix}
          </strong>
          <p>{item.label}</p>
          <span>{item.subLabel}</span>
        </div>
      ))}
    </section>
  )
}
export function RestoredTestimonials() {
  return (
    <section
      className={`${page.container} ${page.section}`}
      aria-labelledby="testimonials-title"
    >
      <div className={page.sectionHeading} data-reveal>
        <div>
          <p className={page.eyebrow}>{sorteeLandingTestimonialsHeading.tag}</p>
          <h2 id="testimonials-title">
            {sorteeLandingTestimonialsHeading.lead}
            <em>{sorteeLandingTestimonialsHeading.highlight}</em>
          </h2>
        </div>
      </div>
      <div className={styles.testimonials}>
        {sorteeLandingTestimonials.map((person) => (
          <figure key={person.name} data-reveal>
            <Rating />
            <blockquote>{person.quote}</blockquote>
            <figcaption>
              <span className={styles.avatar}>{person.initials}</span>
              <div>
                <strong>{person.name}</strong>
                <p>{person.role}</p>
              </div>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  )
}
export function RestoredDashboard() {
  return (
    <div className={styles.dashboardSummary}>
      <div className={styles.legend}>
        <span>{sorteeLandingHeroDashboard.urlPreview}</span>
        <span>{sorteeLandingHeroDashboard.liveBadge}</span>
        <span>{sorteeLandingHeroDashboard.revenueLegend}</span>
        <span>{sorteeLandingHeroDashboard.salesLegend}</span>
        <strong>{sorteeLandingHeroDashboard.growthLabel}</strong>
      </div>
      <div className={styles.notifications}>
        {sorteeLandingFloatingPills.map((pill, index) => (
          <div key={pill.title}>
            <LandingIcon name={index === 0 ? 'check' : index === 1 ? 'star' : 'wheel'} />
            <div>
              <strong>{pill.title}</strong>
              <p>{pill.subtitle}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
export function RestoredFeatureDetails({ featureKey }: { featureKey: string }) {
  if (featureKey === 'dashboard')
    return (
      <dl className={styles.smallMetrics}>
        {sorteeLandingFeatures.dashboard.miniStats.map((item) => (
          <div key={item.label}>
            <dt>{item.label}</dt>
            <dd>{item.value}</dd>
          </div>
        ))}
      </dl>
    )
  if (featureKey === 'roulette')
    return (
      <div className={styles.tags}>
        <span>{sorteeLandingFeaturesVisualContent.wheelCenterLabel}</span>
        {sorteeLandingFeaturesVisualContent.wheelTexts.map((text, index) => (
          <span key={index}>{text}</span>
        ))}
      </div>
    )
  if (featureKey === 'gateway')
    return (
      <div className={styles.tags}>
        {sorteeLandingFeatures.gateway.tags.map((item) => (
          <span key={item.label}>{item.label}</span>
        ))}
      </div>
    )
  if (featureKey === 'capi')
    return (
      <dl className={styles.rows}>
        {sorteeLandingFeatures.capi.funnel.map((item) => (
          <div key={item.label}>
            <dt>{item.label.replace(' ✓', '')}</dt>
            <dd>
              {item.value}
              {item.label.includes('✓') && (
                <LandingIcon name="check" width="14" height="14" />
              )}
            </dd>
          </div>
        ))}
      </dl>
    )
  if (featureKey === 'affiliates')
    return (
      <ul className={styles.affiliates}>
        {sorteeLandingFeatures.affiliates.list.map((item) => (
          <li key={item.name}>
            <span className={styles.avatar}>{item.initials}</span>
            <span>{item.name}</span>
            <strong>{item.value}</strong>
          </li>
        ))}
      </ul>
    )
  if (featureKey === 'campaigns')
    return (
      <dl className={styles.smallMetrics}>
        {sorteeLandingFeatures.campaigns.counters.map((item) => (
          <div key={item.label}>
            <dt>{item.label}</dt>
            <dd>{item.value}</dd>
          </div>
        ))}
      </dl>
    )
  return null
}
export function RestoredStepDemo({ index }: { index: number }) {
  const create = sorteeLandingHowCards.create
  const sales = sorteeLandingHowCards.sales
  const draw = sorteeLandingHowCards.draw
  return (
    <div className={styles.stepDemo}>
      {index === 0 ? (
        <>
          <dl className={styles.sampleFields}>
            {[
              [create.campaignNameLabel, create.campaignNameValue],
              [create.slugLabel, create.slugValue],
              [create.totalNumbersLabel, create.totalNumbersValue],
              [create.numberPriceLabel, create.numberPriceValue],
            ].map(([label, value]) => (
              <div key={label}>
                <dt>{label}</dt>
                <dd>{value}</dd>
              </div>
            ))}
          </dl>
          <Link to={create.actionHref} className={styles.demoAction}>
            Criar campanha <ArrowRightIcon />
          </Link>
        </>
      ) : index === 1 ? (
        <>
          <dl className={styles.rows}>
            {sales.entries.map((entry) => (
              <div key={entry.label}>
                <dt>{entry.label}</dt>
                <dd>
                  {entry.value.replace(' ✓', '')}{' '}
                  <LandingIcon name="check" width="14" height="14" />
                </dd>
              </div>
            ))}
            <div>
              <dt>{sales.totalLabel}</dt>
              <dd>{sales.totalValue}</dd>
            </div>
          </dl>
        </>
      ) : (
        <>
          <LandingIcon name="star" width="28" height="28" />
          <strong className={styles.winnerNumber}>{draw.winnerNumber}</strong>
          <p>{draw.winnerNumberLabel}</p>
          <div className={styles.winner}>
            <span className={styles.avatar}>{draw.winnerInitials}</span>
            <div>
              <strong>{draw.winnerName}</strong>
              <p>{draw.winnerContact}</p>
              <span>{draw.winnerBadge}</span>
            </div>
          </div>
          <span className={styles.demoAction}>
            Publicar resultado <ArrowRightIcon />
          </span>
        </>
      )}
    </div>
  )
}
